import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { EntityHubSmartComponent } from '../entity-hub/entity-hub-smart.component'
import { CollectionsResolver } from '../collections/collections.resolver'
import { EmptyTab } from '../events/components/event-detail/event-tabs/empty-tab/empty-tab.component'
import { SegmentTagV2 } from '../shared/analytics/models/segment-tag.model'

const SCHOOLS_SEGMENT_TAG: SegmentTagV2 = {
  page_category: 'Schools',
  category: 'school',
  autoPageCall: false
}

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: EntityHubSmartComponent,
        resolve: { collection: CollectionsResolver },
        children: [
          {
            path: '',
            component: EmptyTab,
            data: {
              segment: SCHOOLS_SEGMENT_TAG,
              shouldShowAdSkin: false,
              noTopScroll: true,
              shouldShowEventTicker: true
            }
          },
          {
            path: ':tab',
            component: EmptyTab,
            data: {
              segment: SCHOOLS_SEGMENT_TAG,
              shouldShowAdSkin: false,
              noTopScroll: true,
              shouldShowEventTicker: true
            }
          }
        ]
      }
    ])
  ],
  exports: [RouterModule]
})
export class SchoolsRoutingModules {}
